export default __webpack_public_path__ + "static/qaf_newlogo-dca04052ae77fae88a47dae84b51eb12.png";